import Web3Modal from "web3modal";
import { ethers } from "ethers";
import { Token } from "@uniswap/sdk-core";
import { Pool, Position, nearestUsableTick } from "@uniswap/v3-sdk";
import { NON_FUNGIBLE_MANAGER } from "./constants"

const artifacts = {
    NonfungiblePositionManager: require("@uniswap/v3-periphery/artifacts/contracts/NonfungiblePositionManager.sol/NonfungiblePositionManager.json"),
    WETH9: require("./WETH9.json"),
    UniswapV3Pool: require("@uniswap/v3-core/artifacts/contracts/UniswapV3Pool.sol/UniswapV3Pool.json"),
}

const getPoolData = async (poolContract) => {
    const [tickSpacing, fee, liquidity, slot0] = await Promise.all([
        poolContract.tickSpacing(),
        poolContract.fee(),
        poolContract.liquidity(),
        poolContract.slot0()
    ])

    return {
        tickSpacing: tickSpacing,
        fee: fee,
        liquidity: liquidity,
        sqrtPriceX96: slot0[0],
        tick: slot0[1],       
    }
}

export const addLiquidityExternal = async (
    tokenAddress1,
    tokenAddress2,
    poolAddress,
    poolFee,
    tokenAmount1,
    tokenAmount2
) => {
    const web3modal = new Web3Modal();
    const connection = await web3modal.connect();
    const provider = new ethers.providers.Web3Provider(connection);
    const signer = provider.getSigner();
    const accountAddress = await signer.getAddress();

    const token1Contract = new ethers.Contract(tokenAddress1, artifacts.WETH9.abi, provider);
    const token2Contract = new ethers.Contract(tokenAddress2, artifacts.WETH9.abi, provider);

    await token1Contract.connect(signer).approve(NON_FUNGIBLE_MANAGER, ethers.utils.parseEther(tokenAmount1.toString()));
    await token2Contract.connect(signer).approve(NON_FUNGIBLE_MANAGER, ethers.utils.parseEther(tokenAmount2.toString()));

    const poolContract = new ethers.Contract(
        poolAddress,
        artifacts.UniswapV3Pool.abi,
        provider
    );

    const { chainId } = await provider.getNetwork();

    const token1Name = await token1Contract.name();
    const token1Symbol = await token1Contract.symbol();
    const token1Decimal = await token1Contract.decimals();
    const token1Address = token1Contract.address;
    
    const token2Name = await token2Contract.name();
    const token2Symbol = await token2Contract.symbol();
    const token2Decimal = await token2Contract.decimals();
    const token2Address = token2Contract.address;

    const tokenA = new Token(
        chainId,
        token1Address, 
        token1Decimal,
        token1Name,
        token1Symbol
    );

    const tokenB = new Token(
        chainId,
        token2Address, 
        token2Decimal,
        token2Name,
        token2Symbol
    );

    const poolData = await getPoolData(poolContract);
    console.log(poolData);

    const pool = new Pool(
        tokenA,
        tokenB,
        poolData.fee,
        poolData.sqrtPriceX96.toString(),
        poolData.liquidity.toString(),
        poolData.tick
    );

    const position = new Position({
        pool: pool,
        liquidity: ethers.utils.parseEther("1"),
        tickLower: nearestUsableTick(poolData.tick, poolData.tickSpacing) - poolData.tickSpacing * 2,
        tickUpper: nearestUsableTick(poolData.tick, poolData.tickSpacing) + poolData.tickSpacing * 2,        
    });

    const { amount0: amount0Desired, amount1: amount1Desired } = position.mintAmounts;

    const params = {
        token0: token1Address,
        token1: token2Address,
        fee: poolData.fee,
        tickLower: nearestUsableTick(poolData.tick, poolData.tickSpacing) - poolData.tickSpacing * 2,
        tickUpper: nearestUsableTick(poolData.tick, poolData.tickSpacing) + poolData.tickSpacing * 2,  
        amount0Desired: amount0Desired.toString(),
        amount1Desired: amount1Desired.toString(),
        amount0Min: 0,
        amount1Min: 0,
        recipient: accountAddress,
        deadline: Math.floor(Date.now() / 1000) + 60 * 10 //10 MIN make this active
    };

    const nonfungiblePositionManager = new ethers.Contract(
        NON_FUNGIBLE_MANAGER,
        artifacts.NonfungiblePositionManager.abi,
        provider
    );

    const tx = await nonfungiblePositionManager.connect(signer).mint(
        params,
        {
            gasLimit: "1000000"
        }
    );
    console.log("tx sent");

    const receipt = await tx.wait();
    console.log(receipt);

    if (receipt) {
        alert(`Transaction succeed ! Hash : ${receipt["transactionHash"]}`);
    }
    
    return receipt;
}